<template>

<core-modal v-on:close="onCancelClick" icon="caret-left">

	<template v-slot:head>

		<span>Delete</span>

		<small>{{ view.name }}</small>

	</template>

	<template v-slot:default>

		<p>Are you sure you wish to delete the view <b>{{ view.name }}</b>?</p>

	</template>

	<template v-slot:foot>

		<core-button theme="red" v-on:click.native="onConfirmClick" :loading="is.loading">Confirm</core-button>
		<core-button theme="blue" v-on:click.native="onCancelClick">Cancel</core-button>

	</template>

</core-modal>

</template>

<script>

export default {

	props: ['data'],

	data: function() {

		return {

			is: {
				loading: false
			}

		}

	},

	computed: {

		view: function() {

			return this.$store.getters['data/views/associated'][this.data.view]

		}

	},

	methods: {

		onConfirmClick: function() {

			this.is.loading = true

            this.$api.post('views/view/remove', {
				model: this.view
			}).then(function(response) {

				this.$store.commit('data/views/remove', [response])

				this.$emit('close')

				this.$pubsub.$emit('open.modal', {
			    	id: 'viewsManage'
				})

			}.bind(this), function() {

				this.is.error = true
				this.is.loading = false

			}.bind(this)) 	

		},

		onCancelClick: function() {

			this.$emit('close')

			this.$pubsub.$emit('open.modal', {
				id: 'viewsViewSettings',
				view: this.data.view
			})

		}

	}

}

</script>

<style scoped>

</style>